import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";
let env = process.env.REACT_APP_B2B_API_BASE_URL;

  export const cancelTripService = async (data) => {
    const val={
      cancelReason:data?.reason
    }
    const res = await requestInstance
      .post(`${env}${API_ENDPOINT.operations.cancelTrip}${data?.id}`, val)
      .catch((err) => err.response);
    return setCurrentUser(res);
  };

  export const cancelationChargesService = async (data) => {
    const res = await requestInstance
      .post(`${env}${API_ENDPOINT.operations.cancelTrip}${data}/charges`)
      .catch((err) => err.response);
    return setCurrentUser(res);
  };